import React from 'react';
import PropTypes from 'prop-types';

import SidebarSearch from './sidebar_search';

export default class FilterSelector extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    searchText: PropTypes.string,
    searchTextPlaceHolder: PropTypes.string,
    onCancelFilter: PropTypes.func,
    onSearchChange: PropTypes.func.isRequired,
    onSetDefaultFilters: PropTypes.func,
    onSetFilters: PropTypes.func
  };

  static defaultProps = {
    searchTextPlaceHolder: 'Search fields...'
  }

  renderSearchBar() {
    const { searchText, searchTextPlaceHolder, onSearchChange } = this.props;

    return (
      <SidebarSearch
        key="search-bar"
        placeholder={searchTextPlaceHolder}
        size="xs"
        value={searchText}
        onChange={onSearchChange}
      />
    );
  }

  renderDefaultButton() {
    const { onSetDefaultFilters } = this.props;

    if (onSetDefaultFilters == null) return;

    return (
      <div className="default-text" onClick={onSetDefaultFilters}>
        Restore Defaults
      </div>
    );
  }

  render() {
    const { children, onCancelFilter, onSetFilters } = this.props;

    return (
      <div className="filter-selector-popover">
        {this.renderSearchBar()}
        {this.renderDefaultButton()}
        <div className="filter-selector-container">
          {children}
        </div>
        {onCancelFilter &&
          <div className="btn btn-sm btn-cancel right-buffer-sm" onClick={onCancelFilter}>
            Cancel
          </div>
        }
        {onSetFilters &&
          <div className="btn btn-sm btn-save" onClick={onSetFilters}>
            Apply
          </div>
        }
      </div>
    );
  }
}
